import { en, type Dict } from './en'
import { fa, toFa } from './fa'

export type Lang = 'en' | 'fa'

const dicts: Record<Lang, Dict> = { en, fa }

let current: Lang = 'en'

export function setLang(lang: Lang): void {
  current = lang
  const d = dicts[lang]
  document.documentElement.lang = d.meta.code
  document.documentElement.dir = d.meta.dir
  document.documentElement.dataset.lang = lang
}

export function getLang(): Lang {
  return current
}

/** The active dictionary. Call it fresh on every render — language can change mid-session. */
export function t(): Dict {
  return dicts[current]
}

export function isRTL(): boolean {
  return dicts[current].meta.dir === 'rtl'
}

/** Numbers in Persian copy must be Persian, or the sentence reads half-translated. */
export function num(n: number | string): string {
  return current === 'fa' ? toFa(n) : String(n)
}

export function detectLang(): Lang {
  const saved = localStorage.getItem('nabusu.lang')
  if (saved === 'fa' || saved === 'en') return saved
  const nav = navigator.languages ?? [navigator.language]
  return nav.some((l) => l.toLowerCase().startsWith('fa')) ? 'fa' : 'en'
}

export { type Dict }
